import { render, staticRenderFns } from "./BSList.vue?vue&type=template&id=4a802678&"
import script from "./BSList.vue?vue&type=script&lang=js&"
export * from "./BSList.vue?vue&type=script&lang=js&"
import style0 from "./BSList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports